import { useSkinnedAssets } from "hooks/skin";
import { FC, HTMLAttributes, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useWindowSize } from "usehooks-ts";
import { Overlay as ConstantOverlay } from "utils/constants";

export type VideoProps = HTMLAttributes<HTMLDivElement> & {
  
};

export const Video: FC<VideoProps> = ({ ...props }) => {
  const [minimized, setMinimized] = useState(true);
  const { height } = useWindowSize();
  const { thumbnail } = useSkinnedAssets();
  const { t } = useTranslation();

  const handleToggle = () => {
    setMinimized(b => !b);
  };

  return (
    minimized ?
      <Minimize $height={Math.max(160, Math.min(262, 44 + height * 0.25))}>
        <Header>
          <GradText>{t('WATCH INFO VID')}</GradText>
        </Header>
        <Thumbnail $thumbnail={thumbnail} $height={Math.max(120, Math.min(198, 32 + height * 0.19))} onClick={handleToggle} />
      </Minimize>
    :
      <Overlay>
        <Container $height={Math.max(384, Math.min(568, 176 + height * 0.44))}>
          <iframe src="https://player.vimeo.com/video/1181501446?h=28fb17f4ce&badge=0&autoplay=1&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style={{ position: 'relative', width: '100%', height: '100%' }} title="Bounty Hunter Scratchcards">
          </iframe>
          <script src="https://player.vimeo.com/api/player.js"></script>
          <Close onClick={handleToggle} />
        </Container>
      </Overlay>
  );
};

const Overlay = styled(ConstantOverlay)`
  z-index: 1;
`;

const Container = styled.div<{ $height: number }>`
  position: absolute;
  width: ${props => props.$height * 16 / 9}px;
  height: ${props => props.$height}px;
  left: calc((100% - ${props => props.$height * 16 / 9}px) / 2);
  top: calc((100% - ${props => props.$height}px) / 2);
  border-radius: 24px;
  box-shadow: 0 5px 26px 0 #000;
  padding: 4px;
  background-image: linear-gradient(to bottom, #6e6157 0%, #61533b 21%, #cdc28e 54%, #5b4e36 78%, #6c5e51);
  z-index: 0;

  &::before {
    content: "";
    position: absolute;
    left: 4px;
    top: 4px;
    width: calc(100% - 8px);
    height: calc(100% - 8px);
    border-radius: 21px;
    background-color: #000;
    z-index: -1;
  }

  & > iframe {
    border-radius: 21px;
    overflow: hidden;
  }
`;

const Close = styled.div`
  position: absolute;
  top: 0.8vw;
  right: 2.8vw;
  width: 3vw;
  height: 3vw;
  background: url(images/icon-close.svg) center / contain no-repeat;
  cursor: pointer;

   &::after {
    content: "";
    position: absolute;
    left: -5px;
    top: -5px;
    width: calc(100% + 10px);
    height: calc(100% + 10px);
  }
`;

const Thumbnail = styled(Container)<{ $thumbnail: string }>`
  width: calc(100% - 6px);
  height: ${props => props.$height}px;
  top: initial;
  bottom: 0;
  left: 0;
  border-radius: 11px;
  box-shadow: 0 2px 10px 0 #000;
  padding: 3px;
  cursor: pointer;

  &::before {
    left: 3px;
    top: 3px;
    width: calc(100% - 6px);
    height: calc(100% - 6px);
    border-radius: 10px;
    background-image: url(images/play.png), url(${props => props.$thumbnail});
    background-color: transparent, #000;
    background-size: ${props => props.$height * 0.5}px auto, cover;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

const Header = styled.div`
  position: relative;
  margin: 0 auto;
  border-radius: 11px;
  background-image: linear-gradient(to bottom, #6e6157 0%, #61533b 21%, #cdc28e 54%, #5b4e36 78%, #6c5e51);
  z-index: 0;
  text-align: center;
  padding: 3px;

  &::before {
    content: '';
    position: absolute;
    width: calc(100% - 6px);
    height: calc(100% - 6px);
    left: 3px;
    top: 3px;
    border-radius: 10px;
    background-image: linear-gradient(152deg, #663243 0%, #21023a 100%);
    z-index: -1;
  }
`;

const GradText = styled.span`
  background-image: linear-gradient(to bottom, #cf9b5e 15%, #efe090 38%, #cf9b5e 100%);
  letter-spacing: 0.91px;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Minimize = styled.div<{ $height: number }>`
  width: ${props => props.$height * 1.46}px;
  height: ${props => props.$height}px;
  position: absolute;
  left: 4.9vw;
  bottom: 11vh;

  & > ${Header} {
    width: ${props => props.$height * 0.83}px;
    height: ${props => props.$height * 0.44}px;

    & > ${GradText} {
      font-size: ${props => props.$height * 0.13}px;
      line-height: 1.6;
    }
  }
`;
